import { useCallback, useEffect, useState } from 'react';
import type { GeoState } from '../../types';

export function useGeolocation() {
  const [location, setLocation] = useState<GeoState>({ status: 'idle' });

  const request = useCallback(() => {
    if (!navigator.geolocation) {
      setLocation({ status: 'unsupported' });
      return;
    }
    setLocation({ status: 'loading' });
    navigator.geolocation.getCurrentPosition(
      (position) => setLocation({
        status: 'ready',
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy,
      }),
      (error) => setLocation({ status: error.code === error.PERMISSION_DENIED ? 'denied' : 'error' }),
      { enableHighAccuracy: false, timeout: 9000, maximumAge: 60000 },
    );
  }, []);

  useEffect(request, [request]);
  return { location, retry: request };
}
